export default __webpack_public_path__ + "static/media/icon-192x192.d587a60a.png";